'use client';

import useOnChangeNumber from '@src/hooks/useOnChangeNumber';

// Assets
import IInfo from '@public/svg/i-info';

const ModalContact = ({ formData, setFormData }) => {
  const onChangeNumber = useOnChangeNumber();

  return (
    <div className="dd2-xl:flex dd2-xl:flex-col dd2-xl:justify-between dd2-xl:h-full">
      <div>
        <div className="px-6 py-4">
          <p className="font-satoshi-bold text-[21px] leading-[25.2px] text-[#252526]">
            Lengkapi data kontak Anda
          </p>
          <p className="font-satoshi text-[14px] leading-[19.6px] text-[#686A68]">
            Agar marketing kami bisa menghubungi langsung.
          </p>
        </div>

        <div className="flex flex-col gap-4 px-6 py-2">
          <div>
            <p className="text-[14px] mb-1 font-satoshi text-[#252526]">
              Nama Lengkap
            </p>
            <input
              type="text"
              className="w-full h-[40px] px-4 border border-solid border-[#DEDFDE] rounded-[8px] bg-[#fff] text-[#252526] placeholder:text-[#686A68]"
              placeholder="Contoh: Budi Santoso"
              value={formData.name}
              name="name"
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
            />
          </div>
          <div>
            <p className="text-[14px] mb-1 font-satoshi text-[#252526]">
              Nomor WhatsApp
            </p>
            <input
              type="text"
              className="w-full h-[40px] px-4 border border-solid border-[#DEDFDE] rounded-[8px] bg-[#fff] text-[#252526] placeholder:text-[#686A68]"
              placeholder="Contoh: 081234567890"
              value={formData.phone}
              name="phone"
              onChange={(e) => onChangeNumber(e, formData, setFormData)}
            />
          </div>
        </div>
      </div>

      <div className="px-6 py-2 flex items-center gap-2 bg-[#EBF0F7] 
        dd2-xl:absolute dd2-xl:bottom-[66px] dd2-xl:left-0 dd2-xl:right-0 dd2-xl:w-full dd2-xl:z-[43]">
        <IInfo width={16} height={16} color="#3268AE" />
        <p className="font-satoshi text-[11px] leading-[19.6px] text-[#3268AE]">
          Dengan mengirim data, Anda menyetujui{' '}
          <a href="#" className="font-satoshi-bold underline cursor-pointer">
            Syarat Pengguna
          </a>{' '}
          dan{' '}
          <a href="#" className="font-satoshi-bold underline cursor-pointer">
            Kebijakan Privasi
          </a>{' '}
          kami.
        </p>
      </div>
    </div>
  );
};

export default ModalContact;
